import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-sidebar-brand',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="sidebar-brand" [class.collapsed]="collapsed">
      @if (!collapsed) {
        <div class="logo-container">
        <img src="assets/general-media/logo-peekandgo-full-white.svg" alt="logo" class="logo">
      </div>
      } @else {
        <div class="logo-container-collapsed">
          <img src="assets/general-media/playstore.png" alt="logo" class="logo-collapsed">
        </div>
      }
    </div>
  `,
  styles: [`
    .sidebar-brand {
      display: flex;
      align-items: center;
      gap: 0.75rem;
      min-height: 64px;
      border-bottom: 1px solid rgba(255, 255, 255, 0.08);
      flex-shrink: 0;
      height: 64px;
    }

    .logo-container {
      display: flex;
      align-items: center;
      justify-content: center;
      max-width: 130px;
      height: 100%;
      margin: 0 auto;

      .logo {
        max-width: 100%;
        max-height: 100%;
        object-fit: contain;
      }
    }

    .logo-container-collapsed {
      max-width: 50px;
      max-height: 50px;

      .logo-collapsed {
        max-width: 100%;
        max-height: 100%;
        border-radius: 100%;
        border: 3px solid #ffffff52;
        object-fit: contain;  
      }
    }

    .sidebar-brand.collapsed {
      justify-content: center;
      padding: 1rem 0.5rem;
    }

    .brand-text {
      font-size: 1.125rem;
      font-weight: 700;
      letter-spacing: -0.02em;
      color: #fff;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  `]
})
export class SidebarBrandComponent {
  @Input() collapsed = false;
  @Input() brandName = 'PKG Admin';
}
